<template>
  <div class="news">
    <div class="xinwenList">
      <div>
        <div class="line_ddd">
          <div class="line_blue"></div>
        </div>
        <div class="title">
          <span>规章制度</span>
          <router-link to="/policy">
            <span>更多</span>
            <img src="../../../assets/img/more_blue.png" alt="" />
          </router-link>
        </div>
        <div class="dataList">
          <div v-for="(item, index) in zdgzList" :key="index">
            <router-link :to="{ name: '政策法规详情', query: { id: item.id } }">
              <div>
                <img
                  src="../../../assets/img/arrow.png"
                  style="height: 16px; width: 10px; margin-right: 10px"
                />
                <span>{{ item.title }}</span>
              </div>
              <span>[{{ item.logintime }}]</span>
            </router-link>
          </div>
        </div>
      </div>
      <div>
        <div class="line_ddd">
          <div class="line_blue"></div>
        </div>
        <div class="title">
          <span>政策法规</span>
          <router-link to="/policiesRegulations">
            <span>更多</span>
            <img src="../../../assets/img/more_blue.png" alt="" />
          </router-link>
        </div>
        <div class="dataList">
          <div v-for="(item, index) in zcfgList" :key="index">
            <router-link :to="{ name: '政策法规详情', query: { id: item.id } }">
              <div>
                <img
                  src="../../../assets/img/arrow.png"
                  style="height: 16px; width: 10px; margin-right: 10px"
                />
                <span>{{ item.title }}</span>
              </div>
              <span>[{{ item.logintime }}]</span>
            </router-link>
          </div>
        </div>
      </div>
      <div>
        <div class="line_ddd">
          <div class="line_blue"></div>
        </div>
        <div class="title">
          <span>资料下载</span>
          <router-link to="/dataDownload">
            <span>更多</span>
            <img src="../../../assets/img/more_blue.png" alt="" />
          </router-link>
        </div>
        <div class="dataList">
          <div v-for="(item, index) in zlxzList" :key="index">
            <router-link :to="{ name: '资料下载详情', query: { id: item.id } }">
              <div>
                <img
                  src="../../../assets/img/arrow.png"
                  style="height: 16px; width: 10px; margin-right: 10px"
                />
                <span>{{ item.title }}</span>
              </div>
              <span>[{{ item.logintime }}]</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewslist, publicityList } from '@/api/mian'
export default {
  data () {
    return {
      xwdtList: [],
      lunbo: [],
      jyxxList: [],
      zcfgList: [],
      zlxzList: [],
      zdgzList: [],
    }
  },
  async created () {
    let data = {
      number: '001017',
      pageSize: 10,
      pageNum: 1,
      deptId: this.$route.query.parentId
        ? this.$route.query.parentId
        : sessionStorage.getItem('deptId'),
    }
    await getNewslist(data).then((res) => {
      this.xwdtList = res.data.rows
    })
    data = {
      number: '010',
      pageSize: 4,
      pageNum: 1,
      deptId: this.$route.query.parentId
        ? this.$route.query.parentId
        : sessionStorage.getItem('deptId'),
    }
    getNewslist(data).then((res) => {
      this.lunbo = res.data.rows
    })
    data = {
      number: '002001',
      pageSize: 10,
      pageNum: 1,
      deptId: this.$route.query.parentId
        ? this.$route.query.parentId
        : sessionStorage.getItem('deptId'),
    }
    await getNewslist(data).then((res) => {
      this.zcfgList = res.data.rows
    })
    data = {
      number: '007001',
      pageSize: 10,
      pageNum: 1,
      deptId: this.$route.query.parentId
        ? this.$route.query.parentId
        : sessionStorage.getItem('deptId'),
    }
    await getNewslist(data).then((res) => {
      this.zlxzList = res.data.rows
      console.log('zlxz', this.zlxzList)
    })
    data = {
      number: '020',
      pageSize: 10,
      pageNum: 1,
      deptId: this.$route.query.parentId
        ? this.$route.query.parentId
        : sessionStorage.getItem('deptId'),
    }
    await getNewslist(data).then((res) => {
      this.zdgzList = res.data.rows
    })
  },
  mounted () { },
  computed: {},
  watch: {},
  methods: {
    // 跳转到新闻中心
    toxinwen (num, i) {
      this.$router.push({ name: '新闻中心', query: { number: num, idx: i } })
    },
    // 跳转到通知成交鉴定公告页面
    toGonggao (i) {
      this.$router.push({ path: '/announcement', query: { id: i } })
    },

    // 跳转到通知成交鉴定公告页面
    toChengJiao () {
      this.$router.push({ path: '/chengjiaogonggao' })
    },
  },
}
</script>

<style scoped>
ul {
  margin: 0;
  padding: 0;
}

.news {
  width: 100%;
  height: 520px;
  background-color: #ffffff;
}

.lunbo {
}

.lunbo_img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lunbo_title {
  display: block;
  margin: 0;
  box-sizing: border-box;
  padding: 0 130px 0 50px;
  position: absolute;
  bottom: 0;
  width: 750px;
  height: 60px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  line-height: 60px;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-carousel /deep/ .el-carousel__container {
  height: 498px !important;
}

/* ul定位 */
.el-carousel /deep/ .el-carousel__indicators--horizontal {
  left: 600px;
  transform: none;
}

.el-carousel /deep/ .el-carousel__indicators--horizontal .el-carousel__button {
  width: 12.4px;
  height: 12.4px;
  border-radius: 50%;
}
.xinwenList {
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 20px;
}
.xinwenList > div {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.xinwenList > div > .title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xinwenList > div > .line_ddd {
  width: 100%;
  height: 4px;
  background-color: #ddd;
}
.xinwenList > div > .line_ddd > .line_blue {
  width: 170px;
  height: 4px;
  background-color: #2187ff;
}
.xinwenList > div > .title > a {
  display: flex;
  align-items: center;
  color: #667fea;
  cursor: pointer;
}
.xinwenList > div > .title > a > img {
  width: 10px;
  height: 10px;
}
.xinwenList > div > .title > span {
  width: 170px;
  text-align: center;
  line-height: 50px;
  height: 50px;
  font-size: 24px;
  color: #2187ff;
  font-weight: bold;
}
.xinwenList > div > .dataList {
  display: flex;
  flex-direction: column;
}
.xinwenList > div > .dataList > div {
  padding: 10px 0;
}
.xinwenList > div > .dataList > div > a {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xinwenList > div > .dataList > div > a > div {
  display: flex;
  align-items: center;
}
.xinwenList > div > .dataList > div > a > div > span {
  font-size: 18px;
  width: 480px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.right > div {
  flex: 1;
}
</style>
